<template>
    <div class="index-practice-areas-dashboard">

        <div class="main-content">
			<div class="container-fluid">
				<div class="row justify-content-center">
					<div class="col-12 col-lg-10 col-xl-10">

						<!-- Header -->
						<div class="header mt-md-5">
							<div class="header-body">
								<div class="row align-items-center">
									<div class="col">
										<!-- Title -->
										<h1 class="header-title">
											Practice Areas
										</h1>
									</div>
								</div> <!-- / .row -->
							</div>
						</div>

                        <!-- Content -->
                        <div class="card">
                            <div class="card-body">
                                <div class="d-flex flew-row">
                                    <div>
                                        <router-link to="/dashboard/practice-areas/add" class="btn btn-primary px-5">
                                            Add
                                        </router-link>
                                    </div>
                                    <div class="ml-auto mb-4">
                                        <form id="searchForm">
                                            <div class="input-group  mb-3" id="search">
                                                <input type="text" name="search" class="form-control form-control-appended" placeholder="Search.."
                                                    v-model="searchData" v-validate="'required|min:3'" data-vv-as="search"
                                                >
                                                <div class="input-group-append ml-2">
                                                    <div class="input-group-button">
                                                        <button class="btn btn-primary" @click.prevent="dataSearch($event)">
                                                            <i class="fe fe-search"></i>
                                                        </button>

                                                        <button class="btn btn-link close-search" @click.prevent="closeSearch($event)" style="display: none">
                                                            <i class="fe fe-x text-danger"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <span class="text-danger">{{ errors.first('search') }}</span>

                                        </form>
                                    </div>
                                </div>

                                <div id="blockUI">
                                    <div class="table-responsive">
                                        <table class="table table-nowrap" id="practiceTable">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Name</th>
                                                    <th scope="col">content</th>
                                                    <th scope="col">Date Added</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(practice, i) in practices"  :key="i" v-if="practices.length > 0">
                                                    <td>{{ practice.name }}</td>
                                                    <td v-html="practice.content"></td>
                                                    <td>{{ practice.date_created }}</td>
                                                    <td>
                                                        <router-link :to="`/dashboard/practice-areas/${practice.practiceid}/${practice.dash}`" class="btn btn-sm btn-primary"
                                                            data-toggle="tooltip" data-placement="top" title="Edit"
                                                        >
                                                            <i class="fe fe-edit"></i>    
                                                        </router-link>

                                                        <button class="btn btn-danger btn-sm" @click="deleteData(practice.practiceid, i, $event)"
                                                            data-toggle="tooltip" data-placement="top" title="Delete"
                                                        >
                                                            <i class="fe fe-trash-2"></i>
                                                        </button>
                                                    </td>
                                                </tr>

                                                <tr v-if="practices.length <= 0">
                                                    <td colspan="4">
                                                        <p  class="text-center">No data to display</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>

                                    <div class="d-flex flew-row mt-4">
                                        <div class="ml-md-auto">

                                            <b-pagination 
                                                size="sm" 
                                                v-model="currentPage"
                                                :total-rows="pagination.total" 
                                                :per-page="pagination.perPage"
                                            >
                                            </b-pagination>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

					</div>
				</div>
			</div>
        </div>

						
    </div>
</template>

<script>
    import editorOption from '@/assets/js/editorsettings.js'
    import axios from 'axios'
    import pagination from 'vue-pagination-bootstrap'
    export default {
        components: { pagination  },
        name: 'Index',
        data() {
            return {
                practices: [],
                currentPage: 1,
                pagination: {
                    total: 1,
                    perPage: 5
                },
                firstLabel: 'First',
                previousLabel: 'Previous',
                nextLabel: 'Next',
                lastLabel: 'Last',
                searchData: '',
                isSearch: false
                
            }
        },
        metaInfo: {
            title: 'Practice Areas'
        },
        watch: {
            currentPage(n, c) {
                if (this.isSearch) {
                    this.fetchPaginationDataSearch(n);
                    return;
                }
                this.fetchPaginationData(n);
            }
        },
        methods: {
            fetchPaginationData (page) {   
                $('#blockUI').block(editorOption.blockOptions);   
                axios.get(APIURL + 'admin/practices/paginate?page=' + page).then((response) => {

                    let res = response.data;
                    this.practices = res.data;
                    this.pagination.total = res.total;
                    this.pagination.perPage = res.limit;

                    $('#blockUI').unblock();
                })
                .catch((err) => {
                    console.log(err)
                })
            },

            fetchPaginationDataSearch(page) {
                var self = this;
                var search = this.searchData;
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        $.getJSON(APIURL + `admin/practice/search?search=${search}&page=${page}`, function(response) {
                            
                            self.isSearch = true;
                            self.practices = response.data;
                            self.pagination.total = response.total;
                            self.pagination.perPage = response.limit;
                            $('.close-search').show();
                        })
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
            },

            //fetch data
            fetchData() {
                var self = this;
                $('#blockUI').block(editorOption.blockOptions); 
                axios.get(APIURL + 'admin/practices').then((response) => {
                    let res = response.data;
                    this.practices = res.data;
                    this.pagination.total = res.total;
                    this.pagination.perPage = res.limit;
                    $('#blockUI').unblock();
                })
                .catch((err) => {
                    console.log(err)
                })
            },

            //delete data
            deleteData(id, index, e) {
                var self = this;
                var btn = e.currentTarget;

                this.$swal({
                    title: 'Are you sure to delete this?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {

                        $(btn).attr('disabled', '').addClass('is-loading is-loading-sm');

                         $.getJSON(APIURL + 'admin/practices-delete/' + id, (response) => {
                            $(btn).removeAttr('disabled').removeClass('is-loading is-loading-sm');
                            if (response.status == 200) {
                                self.$swal('', response.msg, 'success');
                                
                                if (self.isSearch) {
                                    this.fetchPaginationDataSearch(self.currentPage);
                                    return;
                                }
                                self.fetchPaginationData(self.currentPage);
                                
                            }
                            else if (response.status == 203) {
                                self.$swal('', response.msg, 'error');
                            }
                            else {
                                self.$swal('', response.msg, 'error');
                            }
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                    }
                })
            },

            //Search data
            dataSearch(e) {
                var self = this;
                var btn = e.currentTarget;
                var search = this.searchData;
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        $(btn).attr('disabled', '').addClass('is-loading is-loading-sm');
                        $.getJSON(APIURL + `admin/practice/search?search=${search}&page=${1}`, function(response) {
                            $(btn).removeAttr('disabled').removeClass('is-loading is-loading-sm');
                            
                            self.isSearch = true;
                            self.practices = response.data;
                            self.pagination.total = response.total;
                            self.pagination.perPage = response.limit;
                            $('.close-search').show();
                        })
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
            },

            //close search
            closeSearch(e) {
                var self = this;
                var btn = e.currentTarget;
                
                this.fetchData();

                self.searchData = '';
                self.$validator.reset();

                self.isSearch = false;
                $(btn).hide();
            }
        },
        created() {
            this.fetchData();
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/views/backend/practiceareas/Index.vue